import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { BannerConfig, ConfigService } from "src/app/services/config.service";

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {

  show = false;

  bannerConfigs: BannerConfig[] = [];

  constructor(private configService: ConfigService, domSan: DomSanitizer) {
    this.configService.banners$.subscribe(banners => {
      this.bannerConfigs = banners;
      this.bannerConfigs.forEach(b => {
        if (b.content) {
          b.safe = domSan.bypassSecurityTrustHtml(b.content.join(' '));
        }
      });
    });
  }

  /**
   * Called from the HTML for each banner about to be displayed.
   * @param banner - banner to show or hide
   * @returns true if the banner should be shown on this page.
   */
  showBanner(banner: BannerConfig): boolean {
    const today = new Date();
    if (banner.startDate && today < new Date(banner.startDate))
      return false;
    if (banner.endDate && today > new Date(banner.endDate))
      return false;

    const match = window.location.pathname.match(/(?:.+[/])*(.+)/);
    const path = match ? match[1] : '';
    for (const comp of banner.componentList) {
      if (path.includes(comp.toLowerCase()) || comp == 'all')
        return true;
    }

    return false;
  }
}